import { Box, IconSize } from '@bechtel/gds';
import { AppSpinner } from '../app-spinner';

const LoadingIndicator = () => {
  return (
    <Box style={{ height: '100%', width: '100%' }} justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }}>
      <AppSpinner size={IconSize.MEDIUM}></AppSpinner>
    </Box>
  );
};

export default LoadingIndicator;
